export enum DISTRIBUTION_CHART_LEGEND {
  TOTAL,
  OTHERS,
  NOT_ASSIGNED,
}
